import React from 'react';

import { Button, IconButton, Icons } from '@components/common';

import { ITreePreset } from '@interfaces/components/tree';

import styles from './MoTreeButtons.module.scss';

interface IMoTreeButtonsProps {
	checked: boolean;
	savedPreset?: ITreePreset;
	openPresetForm?: () => void;
	clearAll: () => void;
	handleSubmit: () => void;
	isMavenir?: boolean;
}

const MoTreeButtons = ({
	checked,
	savedPreset,
	openPresetForm,
	clearAll,
	handleSubmit,
	isMavenir,
}: IMoTreeButtonsProps) => (
	<div className={styles.moTreeButtons}>
		{!isMavenir && (
			<IconButton
				icon={Icons.saveIcon}
				isDisabled={!checked || !!savedPreset}
				onClick={openPresetForm}
				tooltipLabel='Save as preset'
			/>
		)}
		<div className={styles.moTreeButtonsRight}>
			<Button
				disabled={!checked || !!savedPreset}
				large
				onClick={clearAll}
				text='Clear all'
				withoutBackground
			/>
			<Button
				disabled={!checked}
				large
				onClick={handleSubmit}
				text='Show result'
			/>
		</div>
	</div>
);

export default MoTreeButtons;
